/* unplugin-vue-components disabled */import { render } from "./MoblieTicket.vue?vue&type=template&id=22fb0640"
import script from "./MoblieTicket.vue?vue&type=script&lang=js"
export * from "./MoblieTicket.vue?vue&type=script&lang=js"

import "./MoblieTicket.vue?vue&type=style&index=0&id=22fb0640&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__